import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";

import { LiveMapContextWrapper } from "./context";
import { LiveMapPageContent } from "./live-map.page.content";

export const LiveMapPage: FC = () => {
  return (
    <PageContextWrapper entity="rideMap">
      <LiveMapContextWrapper>
        <LiveMapPageContent />
      </LiveMapContextWrapper>
    </PageContextWrapper>
  );
};
